import { InjectionToken } from '@angular/core';
import { App } from '@capacitor/app';
import type { AppPlugin } from '@capacitor/app';

export const CAPACITOR_APP_TOKEN = new InjectionToken<AppPlugin>('CapacitorApp');

export function provideCapacitorApp() {
  return {
    provide: CAPACITOR_APP_TOKEN,
    useValue: App,
  };
}
